import {SET_DATA_TITLE_MODAL} from "../../types";

export function setParamsTitleModal(data) {
    return (dispatch) => {
        dispatch({type: SET_DATA_TITLE_MODAL, payload: data});
    }
}